import 'bootstrap';
import Header from './components/Header';
import Carousel from './components/Carousel';
import Footer from './components/Footer';
import MainMenu from './components/MainMenu';
import CyberCookies from './utils/CyberCookies';
import AccordionHashedEntryController from './components/AccordionHashedEntryController';
import PrintButton from './components/PrintButton';
import CopyPageLinkButton from './components/CopyPageLinkButton';
import Filter from './components/Filter';
import InitSelect2 from './utils/InitSelect2';
import LoadMore from './components/LoadMore';
import LightBox from './components/LightBox';
import ThemeFavIcon from './components/ThemeFavIcon';
import CountDown from './components/CountDown';
InitSelect2.mount();
Header.mount();
Footer.mount();
MainMenu.mount();
Carousel.mount();
CyberCookies.mount();
AccordionHashedEntryController.mount();
PrintButton.mount();
CopyPageLinkButton.mount();
Filter.mount();
LoadMore.mount();
LightBox.mount();
ThemeFavIcon.mount();
CountDown.mount();
